import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import React from 'react';
import { IconsList } from './DynamicIcon';

import {
  makeStyles,
  createStyles,
  Theme as AugmentedTheme,
} from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme: AugmentedTheme) =>
  createStyles({
    checked: {},
    menuButton: {
      marginRight: theme.spacing(2),
      color: theme.palette.primary.main,
    },
    optionTitle: {
      display: 'inline-block',
    },
    optionIcon: {
      color: '#FFFFFF',
      position: 'relative',
      top: 5,
    },
    icon: {
      color: theme.palette.primary.light,
    },
  }),
);

export default function UserMenu(props) {
  const classes = useStyles();
  return (
    <div className="App">
      <div className="card-container">
        {props.menu.options.map(option => {
          const Icon = IconsList[option.icon];
          return (
            <ListItem button key={option.link}>
              <Link to={option.link} onClick={props.onClick}>
                <ListItemIcon className={classes.optionIcon}>
                  <Icon className={classes.icon} />
                </ListItemIcon>
                <ListItemText
                  className={classes.optionTitle}
                  primary={option.title}
                />
              </Link>
            </ListItem>
          );
        })}
      </div>
    </div>
  );
}
